var exports = {
  "kL": "AttachmentFile.module__container___NEw4dW",
  "G5": "AttachmentFile.module__deleteButton___NEw4dW",
  "Dq": "AttachmentFile.module__attachmentContainer___NEw4dW",
  "zc": "AttachmentFile.module__iconContainer___NEw4dW",
  "el": "AttachmentFile.module__fileInfoContainer___NEw4dW",
  "Md": "AttachmentFile.module__fileName___NEw4dW",
  "m$": "AttachmentFile.module__fileNameTruncate___NEw4dW",
  "i_": "AttachmentFile.module__fileExtension___NEw4dW",
  "Ov": "AttachmentFile.module__fileSize___NEw4dW",
  "l6": "AttachmentFile.module__downloadButton___NEw4dW",
  "Hj": "AttachmentFile.module__downloadButtonDisabled___NEw4dW",
};

module.exports = exports;
